module.exports = __webpack_public_path__ + "img/ko_iki2.3367e9ce.jpg";